import _objectDestructuringEmpty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from "react";
import { ELSButton } from "components/common/elsevier/Button/Button";
import { updateSessionSettings } from "redux/reducers/sessionSettingsReducer";
import { useDispatch, useSelector } from "react-redux";
import { Events } from "services/adobeAnalytics";
import { selectUsersessionData } from "redux/reducers/userSessionReducer";
import Styles from "./Styles.module.scss";
function Back(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var dispatch = useDispatch();
  var userSession = useSelector(selectUsersessionData);
  var title = userSession.userTextZones["start.page.widget.new.text"];
  var handleClick = function handleClick() {
    Events.startPage.spGuiToggle();
    var updatedSessionSettings = {
      quickSearchPage: "/app/quick/search"
    };
    dispatch(updateSessionSettings(updatedSessionSettings)).then(function (sessionSettingsResponse) {
      if (sessionSettingsResponse.status === "error") {
        console.error("Error during Session Settings update");
      } else {
        var _expirationDate = new Date();
        _expirationDate.setDate(_expirationDate.getDate() + 180); // Expire in 180 days

        var _expires = _expirationDate.toUTCString();
        document.cookie = "START-PAGE-OVERRIDE=old; expires=".concat(_expires, "; path=/");
        window.location = window.location.origin;
      }
    });
  };
  return /*#__PURE__*/React.createElement(ELSButton, _extends({}, props, {
    className: "es-link__black--14-font ".concat(Styles.back, " ev-back-to-original"),
    onClick: handleClick,
    "data-cy": "drawer-button"
  }), title);
}
Back.defaultProps = {};
export default Back;